import React from 'react';
import Layout from '../../../components/Layout/Layout';

import './EmailConfirmation.scss';

const EmailConfirmation = (props) => {
    const { isValidToken, confirmed } = props;

    return (
        <div className="page-User-EmailConfirmation">
            <Layout PAGE_PROPS={props.PAGE_PROPS} />
            <div className="email-confirmation-container">
                {confirmed && (
                    <div className="email-confirmation-success">
                        <h1>Email Confirmed</h1>
                        <p>
                            Your email address has been successfully confirmed.
                            You can now log in.
                        </p>
                        <a
                            href="/login?verified=1"
                            className="email-confirmation-cta"
                        >
                            Go to Login
                        </a>
                    </div>
                )}
                {!isValidToken && !confirmed && (
                    <div className="email-confirmation-error">
                        <h1>Invalid or Expired Link</h1>
                        <p>
                            This confirmation link is no longer valid. Please
                            return to login and resend verification.
                        </p>
                        <a href="/login" className="email-confirmation-cta">
                            Go to Login
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EmailConfirmation;
